import React, { useState } from "react";
import { getKey, getUserMetadata } from "../utils/localStorage";

export const withTitle = (title: string = "izyQ") => (WrappedComponent) => (props) => {
  document.title = "izyQ | " + title;
  return <WrappedComponent {...props} />;
};
